export default "__VITE_PUBLIC_ASSET__1e621bb6__"